export default "__VITE_ASSET__D$WcXcFM__"